import React, {useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Button from "@mui/material/Button";
import { ReactComponent as Editicon } from "./assets/editicon.svg";
import { ReactComponent as Deleteicon } from "./assets/deleteicon.svg";
import { ReactComponent as AddCircleIcon } from "./assets/addcircleicon.svg";
import DeleteUserModal from "./DeleteUserModel";
import AddUser from "./AddUserModel";

const AdduserList = (props:any) => {
  const userdata=props.userRow
  const [orderBy, setOrderBy] = React.useState<string>("");
  const [order, setOrder] = React.useState<"asc" | "desc">("asc");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
 
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [isuserEditDialogOpen, setisuserEditDialogOpen] = useState(false);
  const [userToDelete, setUserToDelete] = useState([]);
  const [UserToEdit ,setUserToEdit]=useState<any>([])
 
  
  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  // const getUserList = async () => {
  //   let baseUrl = process.env.REACT_APP_API_URL;
  //   axios
  //     .get(`${baseUrl}/userlist`)
  //     .then((response: any) => {
  //       setUserRow(response.data);
  //       console.log(response.data);
  //     })
  //     .catch((error) => {
  //       console.log(error.response.data.error);
  //     });
  // };



  const getuserRows = () => {
    const sortedRows = stableSort(userdata, getComparator(order, orderBy));
    const startIndex = page * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    return sortedRows.slice(startIndex, endIndex);
  };

  function getComparator(order: "asc" | "desc", orderBy: string) {
    if (orderBy === "No") {
      // For "No" column (ID column), compare numerical values
      return order === "desc"
        ? (a: any, b: any) => b[orderBy] - a[orderBy]
        : (a: any, b: any) => a[orderBy] - b[orderBy];
    } else {
      // For other columns, compare string values
      return order === "desc"
        ? (a: any, b: any) => descendingComparator(a, b, orderBy)
        : (a: any, b: any) => -descendingComparator(a, b, orderBy);
    }
  }

  // Helper function to compare values for sorting
  function descendingComparator(a: any, b: any, orderBy: string) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  // Stable sorting function to preserve the order of equal elements
  function stableSort(array: any[], comparator: (a: any, b: any) => number) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }
  const sorteduserRows = stableSort(
    getuserRows(),
    getComparator(order, orderBy)
  );

  const handleDeleteItemClick = (row: any) => {
    setUserToDelete(row);
    setDeleteModalOpen(true);
  };
  const handleEditItemClick = (row: any) => {
    setUserToEdit(row)
    setisuserEditDialogOpen(true);
  };
  const handleAddItemClick = (row: any) => {
    setUserToEdit(undefined);
    setisuserEditDialogOpen(true);
  };

  return (
    <>
      <div className="">
        <TableContainer style={{ width: "95%", margin: "0 auto" }}>
          <div className="usrbtn-section">
            <Button className="add-user" startIcon={<AddCircleIcon style={{ color: "#fff" }} />}
                    sx={{ background: "#1D68B3", textTransform: "capitalize" , color:"#fff", width:"150px" }}  
                    onClick={handleAddItemClick}>
                    Add User
            </Button>
          </div>

          <Table aria-label="collapsible table">
            <TableHead sx={{ borderBottom: "2px solid #bfbfbf" }}>
              <TableRow>
                <TableCell className="table-head">Name</TableCell>

                <TableCell className="table-head">Email</TableCell>
                <TableCell className="table-head">Role</TableCell>

                {/* <TableCell className="table-head">Gender</TableCell>
                                            <TableCell className="table-head">Location</TableCell> */}
                <TableCell className="table-head">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {sorteduserRows.map((row: any, index: any) => (
                <TableRow key={index}
                  style={
                    index % 2
                      ? { background: "#fff" }
                      : { background: "rgba(73,134,194,0.11)" }
                  }
                >
                  <TableCell className="table-cell" style={{ width: "15%" }}>
                    {row.name}
                  </TableCell>

                  <TableCell className="table-cell" style={{ width: "15%" }}>
                    {row.email}
                  </TableCell>

                  <TableCell className="table-cell" style={{ width: "15%" }}>
                    {row.role}
                  </TableCell>

                  {/* <TableCell className="table-cell">{row.gender}</TableCell>
                                                <TableCell className="table-cell">{row.location}</TableCell> */}
                  <TableCell className="table-cell" style={{ width: "15%" }}>
                    <Editicon
                      style={{ cursor: "pointer" }}
                      onClick={() => handleEditItemClick(row)}
                    />
                    <Deleteicon
                      style={{ marginLeft: "8px", cursor: "pointer" }}
                      onClick={() => handleDeleteItemClick(row)}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25, 50]}
            component="div"
            count={userdata.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            sx={{
              marginTop: "0.75em",
              color: "#1D68B3",
              "& .MuiIconButton-root.Mui-disabled": {
                color: "rgba(29,104,179,0.60)",
              },
              "& .MuiIconButton-root": {
                color: "#1D68B3",
              },
              "& .MuiTablePagination-select , & .MuiTablePagination-select:focus":
                {
                  border: "1px solid #1D68B3",
                  borderRadius: "5px",
                  background: "transparent",
                  fontWeight: "600",
                },
              ".MuiTablePagination-displayedRows": {
                fontSize: "16px",
                fontWeight: "400",
              },
              ".MuiTablePagination-selectLabel": {
                fontSize: "16px",
                fontWeight: "400",
              },
              ".MuiMenuItem-gutters": {
                background: "red",
              },
            }}
          />
        </TableContainer>
        <DeleteUserModal
          isDeleteModalOpen={isDeleteModalOpen}
          handleCloseDialog={(isOpen: any) => setDeleteModalOpen(isOpen)}
          getUserList={props.getUserList}
          getRowItem={userToDelete}
        />
        <AddUser
          isuserEditDialogOpened={isuserEditDialogOpen}
          handleCloseDialog={() => setisuserEditDialogOpen(false)}
          getuserList={props.getUserList}
          getRowItem={UserToEdit}
        />
      </div>
    </>
    
  );
};

export default AdduserList;
